import { PlusOutlined } from '@ant-design/icons';
import { BaseButton } from 'components/button/button-base';
interface AddPatientButtonProps {
  onClick: () => void;
}

export function AddPatientButton(props: AddPatientButtonProps) {
  return (
    <BaseButton
      onClick={props.onClick}
      icon={<PlusOutlined />}
      iconPosition="end"
    >
      Add test-taker
    </BaseButton>
  );
}
